import axiosInstance from './axiosInstance';
import { cachedGet, invalidate } from './apiCache';
import { Supplier, CreateSupplierDto, UpdateSupplierDto } from '../types/suppliers.types';

const suppliersService = {
  getAll: async (): Promise<Supplier[]> => {
    return cachedGet('suppliers_all', async () => {
      const response = await axiosInstance.get<Supplier[]>('/Suppliers');
      return response.data;
    });
  },

  getById: async (id: number): Promise<Supplier> => {
    const response = await axiosInstance.get<Supplier>(`/Suppliers/${id}`);
    return response.data;
  },

  create: async (supplier: CreateSupplierDto): Promise<Supplier> => {
    const response = await axiosInstance.post<Supplier>('/Suppliers', supplier);
    invalidate('suppliers_');
    return response.data;
  },

  update: async (id: number, supplier: UpdateSupplierDto): Promise<Supplier> => {
    const response = await axiosInstance.put<Supplier>(`/Suppliers/${id}`, supplier);
    invalidate('suppliers_');
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`/Suppliers/${id}`);
    invalidate('suppliers_');
  },

  generateCode: (): string => {
    // Generate simple sequential code like SUP-000001
    const random = Math.floor(Math.random() * 999999) + 1;
    return `SUP-${random.toString().padStart(6, '0')}`;
  }
};

export default suppliersService;